module.exports = __webpack_public_path__ + "static/media/67.ee28cb92.png";